new Vue({
    el:'#wrap',
    data : {
        hotelId:'',
        reviewData:'',
        dataFetched:false,
        scoreData: null,
    },
    computed  : {
        getLang :function(){
            var locale = $.cookie('siteLocale');
            if(!locale) return 'tr'
            else return locale;
        },
        summaryText: function(){
            return this.reviewData.summary.text;
        },
        score : function(){
            return this.getScore(this.reviewData.summary.score);
        },
        reviewCount :function(){
            return this.reviewData.reviews_count;
        },
        hasSingleBadge: function () {
            return this.reviewData != null && this.reviewData.badge_list != null && this.reviewData.badge_list.length == 1;
        },
        hasMultiBadge: function () {
            return this.reviewData != null && this.reviewData.badge_list != null && this.reviewData.badge_list.length > 1;
        },
        badgeListFiltered : function() {
        	var _lst= this.reviewData.badge_list.slice(0,4);
       		return _lst.sort(function(a,b){return (a.badge_data.popularity > b.badge_data.popularity) ? 1 : ((b.badge_data.popularity > a.badge_data.popularity) ? -1 : 0)});
        },
        badgeListAll : function(){
        	var _lst= this.reviewData.badge_list
    		return _lst.sort(function(a,b){return (a.badge_data.popularity > b.badge_data.popularity) ? 1 : ((b.badge_data.popularity > a.badge_data.popularity) ? -1 : 0)});
        }

    },
    methods : {
    	getTextList : function(p) {
    	  var lst=null;
    	  if (p.highlight_list==null || p.highlight_list.length<=0) lst= p.summary_sentence_list
    	  else lst= p.highlight_list;
    	   var result='';
    	  lst.forEach(function(i) {
    		  result += (i.text).endsWith('.') ? i.text :i.text +'.';
    	  })
    	  return result;
    	},
        getScore : function(p) {
            return (p/10).toFixed(1);
        },
        getClass: function(p) {
            if (p > 74 ) return 'progress-bar-success'
            else if (p > 50)  return 'progress-bar-warning'
            else return 'progress-bar-danger'
        },
        fetchReviewData : function(){
            var locale='tr';
            var vm=this;
            var url = "https://api.trustyou.com/hotels/" + vm.hotelId + "/meta_review.json?" + $.param({
                lang: vm.getLang,
                key: "060b36a5-44cd-421e-ac6c-ffced68cdacd",
                v: "5.39"
            });
            $.ajax({
                method: 'GET',
                url: url,
                dataType: "json"
            })
            .then(function (data) {
                    if(data){

                        if (data.meta.code==200) {
                            vm.dataFetched=true;
                            vm.reviewData=data.response;
                            vm.scoreData = {
                                reviewCount: vm.reviewData.reviews_count,
                                score: vm.getScore(vm.reviewData.summary.score),
                                reviewsDistribution: vm.reviewData.summary.reviews_distribution.reverse(),
                                scoreDescription: vm.reviewData.summary.score_description
                            }
                        }
                    }
            })
            .fail(function(error) {
            vm.scoreData = vm.generateScoreDataFromAbiletData();

        })

        },
        generateScoreDataFromAbiletData: function(){
            if (abiletReviewData == null){
                return null;
            }
            var reviews = {
                reviewCount: abiletReviewData.reviewsCount,
                score: abiletReviewData.score,
                reviewsDistribution: [],
                scoreDescription: abiletReviewData.scoreDescription
            };

            var reviewsDistribution = [];
            reviewsDistribution.push({reviews_count: abiletReviewData.reviewsCountStar1, stars: 1});
            reviewsDistribution.push({reviews_count: abiletReviewData.reviewsCountStar2, stars: 2});
            reviewsDistribution.push({reviews_count: abiletReviewData.reviewsCountStar3, stars: 3});
            reviewsDistribution.push({reviews_count: abiletReviewData.reviewsCountStar4, stars: 4});
            reviewsDistribution.push({reviews_count: abiletReviewData.reviewsCountStar5, stars: 5});

            reviews.reviewsDistribution = reviewsDistribution.reverse();

            return reviews;

        },
        progressSize: function(size){
            return Math.round((100 * size) / this.reviewCount);
        },
        scrollTo : function (){
        	 $('html, body').animate({
                 scrollTop: $('#hotelReviewes').offset().top
             }, 400)
        }
    }
    ,
    created : function() {
        if (!isNullOrEmpty(hotelDetailReviewId)){
            this.hotelId=hotelDetailReviewId;
            this.fetchReviewData();
        }
        else{
            this.scoreData = this.generateScoreDataFromAbiletData();
        }
    }



})